import { Colors } from '../Colors';
import { Variables } from '../Variables';
import { Template } from './types';

// хак позволяет типизировать templates и собрать из ключей union (ViewType)
const makeTemplates = <T extends Record<string, Template>>(input: T) => input;

export const templates = makeTemplates({
  primary: {
    static: {
      color: `var(--button-primary-color, ${Colors.text.buttonDefault})`,
      backgroundColor: `var(--button-primary-bg, ${Colors.ut.primary})`
    },
    hover: {
      backgroundColor: `var(--button-primary-hover-bg, ${Colors.ut.primaryUp})`
    },
    active: {
      backgroundColor: `var(--button-primary-active-bg, ${Colors.ut.primaryDown})`
    }
  },

  'primary-dim': {
    static: {
      color: `var(--button-primary-dim-color, ${Colors.text.primary})`,
      backgroundColor: `var(--button-primary-dim-bg, ${Colors.ut.primaryDim})`
    },
    hover: {
      backgroundColor: `var(--button-primary-dim-hover-bg, ${Colors.ut.primaryDimUp})`
    },
    active: {
      backgroundColor: `var(--button-primary-dim-active-bg, ${Colors.ut.primaryDimDown})`
    },
    focus: {
      boxShadowColor: `var(--button-primary-dim-focus-bsc, ${Colors.ut.primaryDimFocus})`
    }
  },

  transparent: {
    static: {
      color: `var(--button-transparent-color, ${Colors.text.default})`,
      backgroundColor: `var(--button-transparent-bg, transparent)`
    },
    hover: {
      backgroundColor: `var(--button-transparent-hover-bg, ${Colors.ut.inputUp})`
    },
    active: {
      backgroundColor: `var(--button-transparent-active-bg, ${Colors.ut.inputDown})`
    },
    focus: {
      boxShadowColor: `var(--button-transparent-focus-bsc, ${Colors.ut.inputFocus})`
    }
  },

  'regular-shadow': {
    static: {
      color: `var(--button-regular-shadow-color, ${Colors.text.default})`,
      backgroundColor: `var(--button-regular-shadow-bg, ${Colors.ut.bgDefault})`,
      boxShadow: `0 1px 1px var(--button-regular-shadow-boxShadow-color, rgba(0, 0, 0, 0.1))`
    },
    hover: {
      boxShadow: `0 1px 1px var(--button-regular-shadow-hover-boxShadow-color, rgba(0, 0, 0, 0.2))`
    },
    active: {
      backgroundColor: `var(--button-regular-shadow-active-bg, ${Colors.ut.inputDown})`,
      boxShadow: `0 1px 1px var(--button-regular-shadow-active-boxShadow-color, rgba(0, 0, 0, 0))`
    },
    focus: {
      boxShadowColor: `var(--button-regular-shadow-focus-bsc, rgba(0, 0, 0, 0.1))`
    }
  },

  'extra-dim': {
    static: {
      color: `var(--button-extra-dim-color, ${Colors.text.default})`,
      backgroundColor: `var(--button-extra-dim-bg, ${Colors.ut.input})`
    },
    hover: {
      backgroundColor: `var(--button-extra-dim-hover-bg, ${Colors.ut.inputUp})`
    },
    active: {
      backgroundColor: `var(--button-extra-dim-active-bg, ${Colors.ut.inputDown})`
    },
    focus: {
      boxShadowColor: `var(--button-extra-dim-focus-bsc, ${Colors.ut.inputFocus})`
    }
  },

  regular: {
    static: {
      color: `var(--button-regular-color, ${Colors.text.default})`,
      backgroundColor: `var(--button-regular-bg, ${Colors.ut.bgDefault})`,
      border: `1px solid var(--button-regular-border, ${Colors.ut.border15})`
    },
    hover: {
      borderColor: `var(--button-regular-hover-border, ${Colors.ut.border30})`
    },
    active: {
      backgroundColor: `var(--button-regular-active-bg, ${Colors.ut.inputDown})`,
      borderColor: `var(--button-regular-active-border, ${Colors.ut.border15})`
    },
    focus: {
      boxShadowColor: `var(--button-regular-focus-bsc, ${Colors.ut.border10})`
    }
  },

  success: {
    static: {
      color: `var(--button-success-color, ${Colors.text.buttonDefault})`,
      backgroundColor: `var(--button-success-bg, ${Colors.ut.success})`
    },
    hover: {
      backgroundColor: `var(--button-success-hover-bg, ${Colors.ut.successUp})`
    },
    active: {
      backgroundColor: `var(--button-success-active-bg, ${Colors.ut.successDown})`
    }
  },

  'success-dim': {
    static: {
      color: `var(--button-success-dim-color, ${Colors.text.success})`,
      backgroundColor: `var(--button-success-dim-bg, ${Colors.ut.successDim})`
    },
    hover: {
      backgroundColor: `var(--button-success-dim-hover-bg, ${Colors.ut.successDimUp})`
    },
    active: {
      backgroundColor: `var(--button-success-dim-active-bg, ${Colors.ut.successDimDown})`
    },
    focus: {
      boxShadowColor: `var(--button-success-dim-focus-bsc, ${Colors.ut.successDimFocus})`
    }
  },

  warning: {
    static: {
      color: `var(--button-warning-color, ${Colors.text.buttonInverse})`,
      backgroundColor: `var(--button-warning-bg, ${Colors.ut.warning})`
    },
    hover: {
      backgroundColor: `var(--button-warning-hover-bg, ${Colors.ut.warningUp})`
    },
    active: {
      backgroundColor: `var(--button-warning-active-bg, ${Colors.ut.warningDown})`
    }
  },

  'warning-dim': {
    static: {
      color: `var(--button-warning-dim-color, ${Colors.text.warning})`,
      backgroundColor: `var(--button-warning-dim-bg, ${Colors.ut.warningDim})`
    },
    hover: {
      backgroundColor: `var(--button-warning-dim-hover-bg, ${Colors.ut.warningDimUp})`
    },
    active: {
      backgroundColor: `var(--button-warning-dim-active-bg, ${Colors.ut.warningDimDown})`
    }
  },

  error: {
    static: {
      color: `var(--button-error-color, ${Colors.text.buttonDefault})`,
      backgroundColor: `var(--button-error-bg, ${Colors.ut.error})`
    },
    hover: {
      backgroundColor: `var(--button-error-hover-bg, ${Colors.ut.errorUp})`
    },
    active: {
      backgroundColor: `var(--button-error-active-bg, ${Colors.ut.errorDown})`
    }
  },

  'error-dim': {
    static: {
      color: `var(--button-error-dim-color, ${Colors.text.error})`,
      backgroundColor: `var(--button-error-dim-bg, ${Colors.ut.errorDim})`
    },
    hover: {
      backgroundColor: `var(--button-error-dim-hover-bg, ${Colors.ut.errorDimUp})`
    },
    active: {
      backgroundColor: `var(--button-error-dim-active-bg, ${Colors.ut.errorDimDown})`
    }
  },

  alert: {
    static: {
      color: `var(--button-alert-color, ${Colors.text.buttonDefault})`,
      backgroundColor: `var(--button-alert-bg, ${Colors.ut.alert})`
    },
    hover: {
      backgroundColor: `var(--button-alert-hover-bg, ${Colors.ut.alertUp})`
    },
    active: {
      backgroundColor: `var(--button-alert-active-bg, ${Colors.ut.alertDown})`
    }
  },

  'alert-dim': {
    static: {
      color: `var(--button-alert-dim-color, ${Colors.ut.alert})`,
      backgroundColor: `var(--button-alert-dim-bg, ${Colors.ut.alertDim})`
    },
    hover: {
      backgroundColor: `var(--button-alert-dim-hover-bg, ${Colors.ut.alertDimUp})`
    },
    active: {
      backgroundColor: `var(--button-alert-dim-active-bg, ${Colors.ut.alertDimDown})`
    },
    focus: {
      boxShadowColor: `var(--button-alert-dim-focus-bsc, ${Colors.ut.alertDimFocus})`
    }
  },

  disabled: {
    static: {
      color: `var(--button-disabled-color, ${Colors.text.disabled})`,
      backgroundColor: `var(--button-disabled-bg, ${Colors.ut.disabled})`
    }
  },

  muted: {
    static: {
      color: `var(--button-landing-dark-color, ${Colors.text.inverse})`,
      backgroundColor: `var(--button-landing-dark-bg, ${Colors.ut.muted})`
    },
    hover: {
      backgroundColor: `var(--button-landing-dark-hover-bg, ${Colors.ut.mutedUp})`
    },
    active: {
      backgroundColor: `var(--button-landing-dark-active-bg, ${Colors.ut.mutedDown})`
    }
  },

  scream: {
    static: {
      color: `var(--button-scream-color, ${Colors.text.buttonDefault})`,
      backgroundColor: `var(--button-scream-bg, ${Colors.ut.scream})`
    },
    hover: {
      backgroundColor: `var(--button-scream-hover-bg, ${Colors.ut.screamUp})`
    },
    active: {
      backgroundColor: `var(--button-scream-active-bg, ${Colors.ut.screamDown})`
    }
  },

  'scream-dim': {
    static: {
      color: `var(--button-scream-dim-color, ${Colors.ut.scream})`,
      backgroundColor: `var(--button-scream-dim-bg, ${Colors.ut.screamDim})`
    },
    hover: {
      backgroundColor: `var(--button-scream-dim-hover-bg, ${Colors.ut.screamDimUp})`
    },
    active: {
      backgroundColor: `var(--button-scream-dim-active-bg, ${Colors.ut.screamDimDown})`
    },
    focus: {
      boxShadowColor: `var(--button-scream-dim-focus-bsc, ${Colors.ut.screamDimFocus})`
    }
  }
});

export const sizeList = {
  XXS: 'var(--button-size-xxs, 1.8rem)',
  XS: 'var(--button-size-xs, 2.4rem)',
  S: 'var(--button-size-s, 3rem)',
  M: 'var(--button-size-m, 4rem)',
  L: 'var(--button-size-l, 5rem)',
  XL: 'var(--button-size-xl, 6rem)'
};

export const fontSizeList = {
  XXS: `var(--button-fs-xxs, ${Variables.typoTextFsXS})`,
  XS: `var(--button-fs-xs, ${Variables.typoTextFsS})`,
  S: `var(--button-fs-s, ${Variables.typoTextFsMCH})`,
  M: `var(--button-fs-m, ${Variables.typoTextFsMCH})`,
  L: `var(--button-fs-l, ${Variables.typoTextFsL})`,
  XL: `var(--button-fs-xl, ${Variables.typoTextFsL})`
};

export const lineHeightList = {
  XXS: `var(--button-lh-xxs, ${Variables.typoTextLhXS})`,
  XS: `var(--button-lh-xs, ${Variables.typoTextLhS})`,
  S: `var(--button-lh-s, ${Variables.typoTextLhMCH})`,
  M: `var(--button-lh-m, ${Variables.typoTextLhMCH})`,
  L: `var(--button-lh-l, ${Variables.typoTextLhL})`,
  XL: `var(--button-lh-xl, ${Variables.typoTextLhL})`
};

export const paddingList = {
  XXS: 'var(--button-padding-xxs, 0 1.2rem)',
  XS: 'var(--button-padding-xs, 0 1.2rem)',
  S: 'var(--button-padding-s, 0 1.4rem)',
  M: 'var(--button-padding-m, 0 2.5rem)',
  L: 'var(--button-padding-l, 0 3rem)',
  XL: 'var(--button-padding-xl, 0 3.5rem)'
};
